import { cn } from '../../../helpers/commonUtils';
import styles from './Button.module.css';
import type { ButtonProps } from './types';

export function Button({
    variant,
    color = 'default',
    size,
    className,
    type = 'button',
    ...props
}: ButtonProps) {
    const variantClassName = variant ? styles[variant] : undefined;
    const colorClassName = color !== 'default' ? styles[color] : undefined;
    const sizeClassName = size ? styles[size] : undefined;

    return (
        <button
            type={type}
            className={cn(styles.button, variantClassName, colorClassName, sizeClassName, className)}
            {...props}
        />
    );
}
